export enum WorkOrderObservationVisibility {
  All = 'domain.enums.observation_visibility.all',
  Company = 'domain.enums.observation_visibility.company',
  Customer = 'domain.enums.observation_visibility.customer',
}

export interface WorkOrderObservation {
  id: number;
  employeeName: string;
  observation: string;
  createdAt: string;
  visibility: WorkOrderObservationVisibility;
  attachments?: string;
}

export interface CreateWorkOrderObservationRequest {
  workOrderComplementId: number;
  observation: string;
  visibility: WorkOrderObservationVisibility;
  attachments?: string;
}

export interface UpdateWorkOrderObservationRequest {
  workOrderComplementId: number;
  observationId: number;
  observation: string;
  visibility: WorkOrderObservationVisibility;
  attachments?: string;
}
